import React from 'react';
// import { Card, CardContent, CardActionArea } from '@material-ui/core';
import { Link } from 'react-router-dom';
import './EpisodeCard.css';
import imagePlayingSound from '../../../../assets/img/EpisodeGrid/centerwhite.webp'

export default function EpisodeCard(props) {
  const { epi } = props;
  const episodePath = `/episode/${epi.episodeId}`;
  const episodeImgPath = epi.coverUrl;
  const audio = epi.trailerUrl ? new Audio(epi.trailerUrl) : null;

  const handleMouseEnter = (e) => {
    if (audio) {
      audio.currentTime = 0;
      audio.play();
      e.currentTarget.src = imagePlayingSound;
    }
  };

  const handleMouseLeave = (e) => {
    if (audio) {
      audio.pause();
      e.currentTarget.src = episodeImgPath;
    }
  };

  return (
    <div className="cardBorder">
      <div className="cardDiv boxShadow"
        onMouseEnter={console.log()}
      >
        <Link to={episodePath} target="_blank">
          <div className="card">
            <div className="cover">
              <img src={episodeImgPath}
                alt={epi.title}
                style={{
                  backgroundImage: `url(${episodeImgPath})`,
                  backgroundSize: `100% 100%`
                }}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              />
            </div>
            <div className="cardContent">
              <div className="cardTitle">{epi.title}</div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
